import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router';
import { connect } from 'react-redux';
import {Redirect} from 'react-router-dom';
import Signin from '../../components/Signin';
import {setAuthData, encodeString} from '../../utils';
import {Api} from '../../api';
import {getAuthToken} from '../../utils';
import queryString from 'query-string';
import { usersActions } from '../../redux/actions';
import './Landing.scss';

class Landing extends Component {
    state = {
        isSigninPopupVisible: false,
        documents: null,
        documentId: '',
        error: '',
        isLoading: false,
        token: null,
        id: null,
    }

    componentDidMount() {
        // http://localhost:8080/#/confirmation?id=5&token=08cd5d9a-4f02-4ae9-b34a-f51d8f4f9ac7
        let params = queryString.parse(this.props.location.search);
        // alert(params.token)
        // alert('222')
        console.log(params, 'params')
        if(params.token && params.id) {
            Api.get(`user/registration_confirm?id=${params.id}&token=${params.token}`)
                .then((response) => {
                    console.log(response, 'response registration_confirm')
                    setAuthData([response.data.access_token, response.data.username ? response.data.username : 'no name', response.data.user_id, encodeString(response.data.role)]);

                    const {dispatch} = this.props;
                    dispatch(usersActions.permissions(response.data.permissions));

                    this.props.history.push('/user');
                }).catch((error) => {
                console.log(error, 'error')
                if (error.response.status === 409) {
                    this.props.history.push('/error?msg=' + error.response.data + "&token=" + params.token);
                    // error.response.data
                }
            })
        }
    }

    render() {
        // console.log(getAuthToken(), 'getAuthToken()')
        if (getAuthToken()) {
            return <Redirect to="/user"/>;
        }

        const {isSigninPopupVisible, documents, documentId, error, isLoading} = this.state;

        return (
            <div className="land">
                <Signin/>
            </div>
        )
    }

    onFileUpload = (e) => {
        const reader = new FileReader();

        reader.onload = (() => {
            return (e) => {
                try {
                    const json = JSON.parse(JSON.parse(e.target.result));

                    Api.post('doc-chain/public/document/search/json', {
                        'hashData': json.hashData
                    }).then((response) => {
                        this.setState({
                            error: '',
                            documents: response.data,
                        });
                        if (response.data.length === 0) {
                            this.setState({
                                error: 'Document not found',
                            })
                        }
                    }).catch((error) => {
                        this.setState({
                            error: 'Document not found',
                        })
                    })
                } catch (ex) {
                    alert('exeption when trying to parse json = ' + ex);
                }
            }
        })(e.target.files[0]);

        reader.readAsText(e.target.files[0]);
    }
}
//
function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(withRouter(Landing));


// export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js